import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, DataRoomTeamMember } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomTeamMemberQuery(
	guid: Guid | undefined,
	userGuid: Guid | null | undefined,
	options?: Omit<UseQueryOptions<DataRoomTeamMember, unknown, DataRoomTeamMember, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomUsers.TeamMemberByUser(guid, userGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomTeamMember>(
				api.get(CerebroApiEndpoints.DataRoomUsers.TeamMemberByUser(guid, userGuid))
			),
		options
	);
}
